import React from 'react';

const DanfeContext = React.createContext();

export default DanfeContext;
